<template>
  <div class="EditorProductSections">
    <div
      :class="['EditorProductSections__block', `EditorProductSections__block--${block.type}`]"
      :key="index"
      v-for="(block, index) in blocks"
    >
      <component :data="block.data" :is="`editor-${$helper.kebabCase(block.type)}`" />
    </div>
  </div>
</template>

<script>
import EditorHeader from '~/components/Editor/EditorHeader';
import EditorParagraph from '~/components/Editor/EditorParagraph';
import EditorImage from '~/components/Editor/EditorImage';
import EditorEmbed from '~/components/Editor/EditorEmbed';
import EditorImageSection from '~/components/Editor/EditorImageSection';
import EditorList from '~/components/Editor/EditorList';
import EditorCodeTool from '~/components/Editor/EditorCodeTool';

export default {
  name: 'EditorProductSections',
  components: {
    'editor-header': EditorHeader,
    'editor-paragraph': EditorParagraph,
    'editor-list': EditorList,
    'editor-image': EditorImage,
    'editor-embed': EditorEmbed,
    'editor-image-section': EditorImageSection,
    'editor-code-tool': EditorCodeTool,
  },
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
    className: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss">
.EditorProductSections {
  &__block {
    margin-bottom: 3rem;

    &:last-child {
      margin-bottom: 0;
    }

    &--header {
      margin-bottom: 1rem;
    }
  }
}
</style>
